<template>
    <LayoutResults v-if="$route.name === 'Results'" />
    <LayoutDefault v-else />
</template>

<script>
import LayoutDefault from '@/apps/quiz/layouts/LayoutDefault.vue';
import LayoutResults from '@/apps/quiz/layouts/LayoutResults.vue';

export default {
    name: 'Quiz',
    components: {
        LayoutDefault,
        LayoutResults
    },
    data () {
        return {
            config: Object.assign(JSON.parse(document.getElementById('quizConfig').text), { navigation: { secondary: false } }),
            globalEls: document.querySelectorAll('.js-quiz-global-els'),
            templateEls: document.querySelector('.js-quiz-template-els-container'),
            data: document.getElementById('app-quiz').dataset,
        }
    },
    mounted() {
        if (this.$route.name === 'results') {
            this.showGlobalEls();
            this.showTemplateEls();
        } else {
            this.hideGlobalEls();
            this.hideTemplateEls();
        }
    },
    methods: {
        showGlobalEls () {
            this.globalEls.forEach(element => {
                element.classList.remove('!hidden');
            });
        },
        hideGlobalEls () {
            this.globalEls.forEach(element => {
                element.classList.add('!hidden');
            });
        },
        showTemplateEls () {
            this.templateEls.classList.remove('hide-quiz-template-els');
        },
        hideTemplateEls () {
            this.templateEls.classList.add('hide-quiz-template-els');
        }
    }
};
</script>
